











































































import Vue from 'vue';

export default Vue.extend({
  name: "Dropdown",
  props: [
    'options',
    'value',
    'nulltext'
  ],
  data() {
    return {
      selecting: false
    }
  },
  methods: {
    SelectItem: function(id: number): void {
      this.$emit('input', id);
    },
    ToggleDropDown: function(): void {
      this.selecting = !this.selecting;
    }
  },
  computed: {
    selectedElement: function() {
      for(let i = 0; i < Object.keys(this.options).length; i++){
        const key = Object.keys(this.options)[i];
        if(this.value == this.options[key].id){
          return this.options[key];
        }
      }

      return false;
    }
  }
});
